import kebabCase from 'lodash.kebabcase'
import { isObject } from './utils'

export const objToCamelCase = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.replace(/[-|_]([a-z])/g, (_, letter) => letter.toUpperCase())
    acc[camelKey] = obj[key]
    return acc
  }, {} as Record<string, any>)
}

export const objToSnakeCase = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).reduce((acc, key) => {
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
    acc[snakeKey] = obj[key]
    return acc
  }, {} as Record<string, any>)
}

export const transformToKebabCase = (targetObject: object): object => {
  if (Array.isArray(targetObject)) {
    return targetObject.map((value) => transformToKebabCase(value))
  } else if (!isObject(targetObject)) {
    return targetObject
  }

  const transformed: any = {}
  const keys = Object.keys(targetObject)

  for (const key of keys) {
    const value = targetObject[key]
    const transformedKey = kebabCase(key)

    if (Array.isArray(value)) {
      transformed[transformedKey] = value.map((v) => transformToKebabCase(v))
    } else if (isObject(value)) {
      transformed[transformedKey] = transformToKebabCase(value)
    } else {
      transformed[transformedKey] = value
    }
  }

  return transformed
}
